// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const attendingPrompt_noUpdatesDetail = (i) => `So erfährst du nicht wenn der Event abgesagt wird oder der Veranstalter wichtige Änderungen macht.`